export default __webpack_public_path__ + "locales/si/PrivacyPage.json?hash=6e893711ba1a0dc4e65b930a2f362fb9";